import { QueryParameterSchema } from './types';

export const campusFilterQueryFilter: QueryParameterSchema<'campusIds'> = {
  getDefaultValue: () => [],
  getValue: ({ queryParameters }) => queryParameters.campusIds,

  fromUrlSearchParams: ({ urlSearchParams }) => ({
    campusIds: (urlSearchParams.get('filter[campusIds]') ?? '').split(','),
  }),
  toUrlSearchParams: ({ value }) => ({ 'filter[campusIds]': value.join(',') }),
  toSearchQuery: ({ value }) => {
    if (!value || value.length === 0) return {};
    return { 'filter[campusIds]': value };
  },
  sanitize: ({ value, staticProps }) => {
    const {
      referenceData: { campuses },
    } = staticProps;
    return { campusIds: value.filter((s) => !!s && !!campuses[s]) };
  },
  getSummaryItems: ({
    value,
    staticProps: {
      referenceData: { campuses },
    },
  }) => {
    return value.map((campus) => ({
      filterKey: 'campusIds',
      key: campus,
      label: `${campuses[campus]?.name}`,
      value: campus,
    }));
  },
  removeParam: ({ value, removedValue }) => {
    return { campusIds: value.filter((item) => item !== removedValue) };
  },
};
